function downloadUrlWithAnchor(url: string, filename?: string): void {
  // Cria um elemento <a> temporário para fazer o download
  const anchor = document.createElement('a');
  anchor.href = url;
  if (filename) {
    anchor.download = filename;
  }
  document.body.appendChild(anchor);
  anchor.click();

  // Limpa
  document.body.removeChild(anchor);
}

function downloadBlobWithAnchor(blob: Blob, filename?: string): void {
  // Cria uma URL temporária para o blob
  const objectUrl = URL.createObjectURL(blob);
  downloadUrlWithAnchor(objectUrl, filename);

  // Limpa a URL temporária
  URL.revokeObjectURL(objectUrl);
}

function downloadUrlWithIframe(url: string): void {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = url;
  document.body.appendChild(iframe);
  setTimeout(() => iframe.remove(), 15_000);
}

export { downloadUrlWithAnchor, downloadBlobWithAnchor, downloadUrlWithIframe };
